import axios from "axios";
import api from "../../lib/api";
export default {
  namespaced: true,
  state: {
    servers: [],
    server: {}
  },
  mutations: {
    setOne(state, payload) {
      state.server = payload;
    },
    clear(state) {
      state.server = {};
    },
    setAll(state, payload) {
      state.servers = payload;
    }
  },
  actions: {
    getAll({ commit }, payload) {
      axios(`${api()}/servers`)
        .then(res => {
          commit("setAll", res.data.docs);
          // this.servers = res.data.docs;
        })
        .catch(err => {
          console.warn(err);
        });
    },
    getOne({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios(`${api()}/servers/${payload}`)
          .then(res => {
            commit("setOne", res.data);
            resolve(res.data);
          })
          .catch(err => {
            // console.warn(err);
            reject(err);
          });
      });
    },
    save({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(`${api()}/servers/${payload._id}`, payload)
          .then(res => {
            commit("setOne", res.data);
            resolve(res.data);
          })
          .catch(err => {
            // console.warn(err);
            reject(err);
          });
      });
    },
    create({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${api()}/servers/`, payload)
          .then(res => {
            commit("setOne", res.data);
            resolve(res.data);
          })
          .catch(err => {
            // console.warn(err);
            reject(err);
          });
      });
    }
  },
  getters: {
    server: state => state.server,
    servers: state => state.servers
    // user: state => {
    //   console.warn(typeof state.user);
    //   console.warn(state.user);

    //   return typeof state.user !== "object" && state.user !== ""
    //     ? JSON.parse(state.user)
    //     : state.user;
    // },
    // isLogged: state => !!state.user,
    // authStatus: state => state.status
  }
};
